// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { authorizeMaple, login, signup } from '../../actions/maple-login';
import type { FormError } from '../../store/reducers/auth';
import MapleDot from '../../assets/images/maple-dot.svg';
import PartnerLogin from '../partner-login-template';

type State = {}

type Props = {
  location: any,
  setFormErrors: (errors: FormError[]) => void,
  authorizeMaple: (redirectUri: string) => Promise<void>,
  login: (email: string, password: string) => void,
  signup: (email: string, password: string) => void,
  user: Object
};


class MapleLogin extends Component<Props, State> {
  props: Props;

  connectMaple = () => {
    this.props.authorizeMaple(this.props.location.search);
  }

  render() {
    return (<PartnerLogin
      location={this.props.location}
      partnerInfo={{
        shortName: 'Maple',
        longName: 'Maple Corporation',
        website: 'www.getmaple.ca',
        exchangeImage: MapleDot
      }}
      connectPartner={this.connectMaple}
      login={this.props.login}
      signup={this.props.signup}
      canDisconnect
            />);
  }
}

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, {
  authorizeMaple,
  login,
  signup
})(MapleLogin);



// WEBPACK FOOTER //
// ./src/components/pages/maple-login.js